import React, { forwardRef } from 'react';
import styles from './Card.module.css';

export type CardSurface = 'default' | 'alt' | 'metric' | 'none';
/** md is radius-400, lg radius-500. */
export type CardRadius = 'md' | 'lg';

export interface ICardProps extends React.HTMLAttributes<HTMLElement> {
  as?: 'div' | 'section' | 'article';
  /** none leaves the background to the page. */
  surface?: CardSurface;
  radius?: CardRadius;
}

const Card = forwardRef<HTMLElement, ICardProps>(
  ({ as = 'div', surface = 'default', radius = 'lg', className, children, ...rest }, ref) => {
    const Root = as as 'div';
    const classes = [
      styles.card,
      surface !== 'none' && styles[surface],
      radius === 'md' && styles.md,
      className,
    ];

    return (
      <Root
        ref={ref as React.Ref<HTMLDivElement>}
        className={classes.filter(Boolean).join(' ')}
        {...rest}
      >
        {children}
      </Root>
    );
  },
);

Card.displayName = 'Card';

export default Card;
